import MyFlow from "flow/MyFlow";
import ko from "knockout";

export default class SilentTask extends MyFlow {
    numberOfSilentlyOngoingTasks = ko.observable(0);
    isLoading = ko.pureComputed(() => this.numberOfSilentlyOngoingTasks() > 0);

    constructor(
        public readonly myFlow: MyFlow,
        private readonly startLoading?: () => void,
        private readonly stopLoading?: () => void
    ) {
        super(myFlow.manifest, myFlow.settings);

        this.isLoading.subscribe((isLoading: boolean) => {
            if (isLoading) {
                if (this.startLoading) {
                    this.startLoading();
                }
            } else {
                if (this.stopLoading) {
                    this.stopLoading();
                }
            }
        });
    }

    addTask = (promise: JQueryPromise<any>) => {
        this.numberOfSilentlyOngoingTasks(this.numberOfSilentlyOngoingTasks() + 1);

        promise.always(() => {
            this.numberOfSilentlyOngoingTasks(this.numberOfSilentlyOngoingTasks() - 1);
        });
    };

    addTaskPromise = (promise: Promise<any>) => {
        this.numberOfSilentlyOngoingTasks(this.numberOfSilentlyOngoingTasks() + 1);

        promise.finally(() => {
            this.numberOfSilentlyOngoingTasks(this.numberOfSilentlyOngoingTasks() - 1);
        });
    };
}
